import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-32bbb632"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["href"];

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 共有 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 个教案，查看全部 > ");

const _hoisted_4 = {
  class: "list-warp"
};
const _hoisted_5 = {
  key: 0,
  class: "no-data"
};
import SectionContainer from './SectionContainer.vue';
import CardHeader from '../../components/CardHeader.vue';
import ListItem from '../../teachingCenterList/components/ListItem/index.vue';
import { Empty } from 'zhs-components';
export default {
  props: {
    menu: {
      type: Object,
      default: () => ({})
    }
  },

  setup(__props) {
    const props = __props;
    const $http = inject('$http');
    provide('menuInfo', ref(props.menu));
    const caseList = ref([]);
    const total = ref(0);

    const getHomeCaseList = async () => {
      const res = await $http.getExcellentCaseList({
        sort_type: 2
      });
      console.log('首页-教案', res);
      caseList.value = res.content;
      total.value = +res.totalElements;
    };

    getHomeCaseList();
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(SectionContainer, {
        title: __props.menu.module_name
      }, {
        action: _withCtx(() => [_createElementVNode("a", {
          href: `/teachingCenterList.html?name=${__props.menu.module_name}&menuId=${__props.menu.menu_id}`
        }, [_hoisted_2, _createElementVNode("u", null, _toDisplayString(total.value), 1), _hoisted_3], 8, _hoisted_1)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(caseList.value.slice(0, 4), item => {
          return _openBlock(), _createBlock(ListItem, {
            class: "item",
            key: item.id,
            caseData: item
          }, null, 8, ["caseData"]);
        }), 128))]), caseList.value.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_unref(Empty), {
          text: "暂无教研教案"
        })])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["title"]);
    };
  }

};